import axios from './axios.js'

const remoteBaseURL = 'https://g.app.universalbeijingresort.com/'; // 生产
// const remoteBaseURL = 'https://tg.app.universalbeijingresort.com/test/'; // 测试
// const remoteBaseURL = 'https://eg.app.universalbeijingresort.com/uat/'; // uat

// 本地开发走 vue.config.js 的 /api 代理，避免浏览器跨域
const baseURL = process.env.NODE_ENV === 'development' ? '/api/' : remoteBaseURL

export const GetNewsList = (params) => {
  return axios.request({
    url: baseURL + 'h5/user_location',
    method: 'get',
    crossDomain: true, //设置跨域为true
    params: params,
  })
}
export const GetDownloadurl = (params) => {
  return axios.request({
    url: baseURL + 'h5/download/url',
    method: 'get',
    crossDomain: true, //设置跨域为true
    params: params,
  })
}
